import { BrowserRouter, Routes, Route, Switch } from "react-router-dom";

import Inicio from './components/Inicio/Inicio';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Transparencia from './components/Transparencia/Transparencia';
import Rubros from './components/Rubros/Rubros';
import DetalleRubro from './components/DetalleRubro/DetalleRubro';
import RubrosHistoricos from "./components/RubrosHistoricos/RubrosHistoricos";
import Agenda from "./components/Agenda/Agenda";
import Protocolo from './components/Protocolo/Protocolo';
import Error404 from "./components/Error404/Error404";
import Analytics from "./components/Analytics/Analytics";

function App() {
  return (
    <BrowserRouter>
      <Analytics />
      <Header/>
        <Routes>
          <Route exact path="/" element={ <Inicio /> } />
         
          <Route exact path="/Transparencia" element={ <Transparencia/> } />
          <Route exact path="/Transparencia/Rubros" element={ <Rubros/> } />
          <Route exact path="/Transparencia/Rubros/DetalleRubro/:nombre" element={ <DetalleRubro/> } />
          <Route exact path="/Transparencia/Rubros/RubrosHistoricos" element={ <RubrosHistoricos/> } />
          <Route exact path="/Protocolo" element={ <Protocolo/> } />
          <Route exact path="/Agenda" element={ <Agenda/> } />
          <Route exact path="*" element={<Error404 /> } />
        </Routes>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
